import {
  GET_PROJECTS_OF_CONTACT,
  ERROR_XHR
} from '../mutation-types'

const state = {
  all: [],
  projectsOfContact: {}
}

const mutations = {
  [GET_PROJECTS_OF_CONTACT] (state, projectsOfContact) {
    // console.log(JSON.stringify(projectsOfContact))
    state.all = projectsOfContact
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/contactProjects.js